module.exports = __webpack_public_path__ + "img/al-jazeera-english.0a28f031.png";